import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { EVENT_BUS_EVENTS, EventBus } from "../../utils/useEventBus";

const EventBusJailService = ({ eventBus }) => {
  const [inmatesByMfe, setInmatesByMfe] = useState({
    browse: {},
    content: {},
    home: {},
    search: {}
  });

  useEffect(() => {
    eventBus.on(EVENT_BUS_EVENTS.INMATE_INTAKE, (context) => {
      const { receivingMfe, inmateId } = context;
      if (!inmatesByMfe[receivingMfe]) {
        inmatesByMfe[receivingMfe] = {};
      }

      const receivingMfeToUpdate = inmatesByMfe[receivingMfe] || {};
      receivingMfeToUpdate[inmateId] = context;
      const updatedInmateRoster = {
        ...inmatesByMfe,
        [receivingMfe]: receivingMfeToUpdate
      };
      setInmatesByMfe(updatedInmateRoster);
    });
    return () => eventBus.detach(EVENT_BUS_EVENTS.INMATE_INTAKE);
  }, [eventBus]);

  useEffect(() => {
    eventBus.on(EVENT_BUS_EVENTS.POST_BAIL_FOR_INMATE, (context) => {
      const { requestingMfe, inmateEventRequested } = context;
      const matchingInmate = inmatesByMfe[requestingMfe][inmateEventRequested];
      if (matchingInmate) {
        eventBus.emit(matchingInmate.inmateId, null, matchingInmate);
        const updatedRequestingMfeInmateRoster = inmatesByMfe[requestingMfe];
        delete updatedRequestingMfeInmateRoster[inmateEventRequested];
        setInmatesByMfe({
          ...inmatesByMfe,
          [requestingMfe]: updatedRequestingMfeInmateRoster
        });
      }
    });
    return () => eventBus.detach(EVENT_BUS_EVENTS.POST_BAIL_FOR_INMATE);
  }, [eventBus]);

  return <></>;
};

EventBusJailService.displayName = "EventBusJailService";
EventBusJailService.propTypes = {
  eventBus: PropTypes.object
};
export default EventBusJailService;
